export const detailedComparisonTableColumnTitles = {
  creator: 'Creator',
  creatorUserName: 'OnlyFans Name',
  totalRevenue: 'Total Revenue',
  newSubs: 'New Subs',
  newSubscriptionsRevenue: 'New Subs Revenue',
  recurringSubscriptionsRevenue: 'Rec. Subs Revenue',
  tipsRevenue: 'Tips Revenue',
  messageRevenue: 'Message Revenue',
  textingRatio: 'Texting Ratio',
  openChats: 'Open Chats',
  averageFanSpend: 'Average Fan Spend',
  sellingChats: 'Selling Chats',
  linkClicks: 'Link Clicks',
  conversionRate: 'Conversion Rate',
} as const
